import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class PrivacyList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return <div className={styles.privacy_txt} dangerouslySetInnerHTML={{ __html: content.privacytList }} />;
    }
}

export default PrivacyList;
